import { useEffect, useState } from "react";
import api from "../../lib/api";
import { X } from "@phosphor-icons/react";

export default function PopupAdManager({ placement = "landing" }) {
  const [ad, setAd] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("tsc_popup_dismissed");
    if (dismissed) return;
    api.get(`/popup-ads/active`, { params: { placement } })
      .then(({ data }) => { if (data && data.length) setAd(data[0]); })
      .catch(() => {});
  }, [placement]);

  if (!ad || hidden) return null;
  const dismiss = () => { sessionStorage.setItem("tsc_popup_dismissed", "1"); setHidden(true); };

  return (
    <div className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-5" data-testid="popup-ad">
      <div className="relative max-w-lg w-full tsc-card overflow-hidden gold-border">
        <button onClick={dismiss} className="absolute top-3 right-3 z-10 text-white/70 hover:text-white p-1.5 rounded-full bg-black/50" data-testid="popup-ad-close"><X size={18} /></button>
        {ad.image_url && <img src={ad.image_url} alt={ad.title} className="w-full aspect-video object-cover" />}
        <div className="p-6">
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">Featured Announcement</p>
          <p className="font-display text-2xl text-white mt-2">{ad.title}</p>
          {ad.body && <p className="text-white/70 text-sm mt-3">{ad.body}</p>}
          {ad.cta_text && (
            <a href={ad.cta_url || "#"} className="tsc-btn-gold inline-block mt-5" data-testid="popup-ad-cta" onClick={dismiss}>{ad.cta_text}</a>
          )}
        </div>
      </div>
    </div>
  );
}
